export const GET_USER_ERROR = 'GET_USER_ERROR';
export const GET_USER_PROCESSING = 'GET_USER_PROCESSING';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
